export enum SystemErrors {
  NONE,
  INVALID_SHORT_TERM_TOKEN,
  CRITICAL_ERROR,
}

export enum UserInteractions {
  NONE,
  CLICK,
  WHEEL,
}
